export const rootPaths = {
  root: '/',
  errorsRoot: 'errors',

  pdcRoot: 'pdc',
  metodologiaRoot: 'metodologia',
  questionarioRoot: 'questionario',
  outputRoot: 'output',
  infoRoot: 'info',

  layoutRoot: 'layouts'
};

export default {
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,

  presentazione: `/${rootPaths.metodologiaRoot}/presentazione`,
  faseA: `/${rootPaths.metodologiaRoot}/fase-a`,
  faseB: `/${rootPaths.metodologiaRoot}/fase-b`,
  faseC: `/${rootPaths.metodologiaRoot}/fase-c`,
  output: `/${rootPaths.metodologiaRoot}/output`,

  analisiStrategica: `/${rootPaths.questionarioRoot}/analisi-strategica`,
  selezioneStakeholder: `/${rootPaths.questionarioRoot}/selezione-stakeholder`,
  selezioneAmbiti: `/${rootPaths.questionarioRoot}/selezione-ambiti`,
  selezioneAnni: `/${rootPaths.questionarioRoot}/selezione-anni`,
  compilaQuestionarioAmbito: (ambitoCsvcCodice) =>
    `/${rootPaths.questionarioRoot}/compila-questionario${ambitoCsvcCodice ? `/${ambitoCsvcCodice}` : ''
    }`,

  riepilogoQuestionario: `/${rootPaths.outputRoot}/riepilogo-questionario`,
  doppiaMatriceMaterialita: `/${rootPaths.outputRoot}/doppia-matrice-materialita`,
  valoreAggiuntoRiattribuito: `/${rootPaths.outputRoot}/valore-aggiunto-riattribuito`,

  alfa: `/${rootPaths.infoRoot}/alfa`,
  beta: `/${rootPaths.infoRoot}/beta`,
  gamma: `/${rootPaths.infoRoot}/gamma`,
}
